import { Component, inject, signal } from '@angular/core'
import { FormsModule } from '@angular/forms'
import { MatIconButton } from '@angular/material/button'
import { MatCheckbox } from '@angular/material/checkbox'
import { MatFormField, MatLabel } from '@angular/material/form-field'
import { MatIcon } from '@angular/material/icon'
import { MatInput } from '@angular/material/input'
import { MatTab, MatTabGroup } from '@angular/material/tabs'
import {
  ElderCardComponent,
  ElderCardContentDirective,
  ElderCardHeaderActionsDirective,
  ElderCardHeaderComponent,
  ElderCardSubtitleDirective,
  ElderCardTitleDirective,
  ElderLanguageSwitcherComponent,
  ElderSinglePaneWrapperComponent,
  ElderToastService,
} from '@elderbyte/ngx-starter'
import { ElderTranslatePipe } from '@elderbyte/ngx-starter'
import { SettingsService } from './settings.service'
import { createSettings, UtopSettings } from './utop-settings'
import { filter } from 'rxjs'
import { takeUntilDestroyed } from '@angular/core/rxjs-interop'

@Component({
  selector: 'app-settings',
  templateUrl: './settings.component.html',
  styleUrls: ['./settings.component.scss'],
  imports: [
    MatTabGroup,
    MatTab,
    ElderCardComponent,
    ElderCardHeaderComponent,
    ElderCardTitleDirective,
    ElderCardContentDirective,
    FormsModule,
    ElderCardSubtitleDirective,
    ElderLanguageSwitcherComponent,
    ElderCardHeaderActionsDirective,
    MatIconButton,
    MatIcon,
    MatFormField,
    MatInput,
    MatLabel,
    MatCheckbox,
    ElderTranslatePipe,
    ElderSinglePaneWrapperComponent,
  ],
})
export class SettingsComponent {
  /***************************************************************************
   *                                                                         *
   * Fields                                                                  *
   *                                                                         *
   **************************************************************************/

  public settings = signal<UtopSettings>(createSettings())
  private toastService = inject(ElderToastService)
  private settingsService: SettingsService

  /***************************************************************************
   *                                                                         *
   * Constructor                                                             *
   *                                                                         *
   **************************************************************************/

  constructor() {
    this.settingsService = inject(SettingsService)
    this.settingsService
      .getSettings()
      .pipe(
        takeUntilDestroyed(),
        filter((settings) => settings && settings.length > 0)
      )
      .subscribe({
        next: (settings) => this.settings.set(settings[0]),
        error: (err) => this.toastService.error('messages.loading_failed', err),
      })
  }

  /***************************************************************************
   *                                                                         *
   * Public API                                                              *
   *                                                                         *
   **************************************************************************/

  public onSave(): void {
    const currentSettings = this.settings()
    if (currentSettings) {
      this.settingsService.updateSettings(currentSettings).subscribe({
        next: (settings) => {
          this.settings.set(settings)
          this.toastService.info('messages.persisting_successful')
        },
        error: (err) => this.toastService.error('messages.loading_failed', err),
      })
    }
  }
}
